import { render, staticRenderFns } from "./MatrixMultipleChoice.vue?vue&type=template&id=0a649e42"
import script from "./MatrixMultipleChoice.vue?vue&type=script&lang=js"
export * from "./MatrixMultipleChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports